import { GeofenceRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * saveGeofenceByCustomerAndDepartment - Function that saves on database a new geofence by department   
 * /geofences  
 * method POST  
 * @async-function
 */
const saveGeofenceByCustomerAndDepartment = async (token: string, model: GeofenceRequestType) => {
    const response = await api.post(
        `/geofences`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default saveGeofenceByCustomerAndDepartment;